import styled from 'styled-components';
import { ReactComponent as Shield } from '../../assets/img/shield.svg';
import { fontDisplay } from '../../theme/typography';

export const StyledWinner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 110px;
  height: 165px;
  img {
    max-width: 80px;
    max-height: 80px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
export const StyledLabel = styled.span`
  ${fontDisplay};
  font-size: 16px;
  letter-spacing: 0.08em;
  color: #fdca40;
`;

export const StyledSeparator = styled.div`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  margin: 15px 0;
`;

export const StyledNoWinner = styled(Shield)`
  width: 60px;
  path {
    fill: ${({ theme }) => theme.border};
  }
`;
